export default __webpack_public_path__ + "static/ProximaNova-Light-ed2ae142b8cffbfbda21b51d23d65496.woff2";